var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-nav-tab"},_vm._l((_vm.options),function(option){return _c('button',{key:option.id,staticClass:"btn",class:{ active: _vm.value === option.id },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('input', option.id)}}},[_vm._v(" "+_vm._s(option.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }